import axios from "axios";

const instance = axios.create({
  baseURL: "https://mern-law-app.onrender.com/",
});

export default instance;
